import AdsCampaignReducer from "./reducer";

export const setNewAdvertisement = (payload) => (dispatch) => {
  dispatch(AdsCampaignReducer.actions.setNewAdvertisement(payload));
};

export const clearNewAdvertisement = () => (dispatch) => {
  dispatch(AdsCampaignReducer.actions.clearedNewAdvertisement());
};
